<h3 class="pt-3" style=" color:#B9B9C3;font-family:Montserrat, Helvetica, Arial;font-size: 1rem;font-weight: 400;"></h3>
<table class="table table-striped table-bordered " style="width: 100%">

  <thead style="background-color:#F3F2F7; width: 1px;">
    <tr >
      <th >S.No</th>
      <th>Name</th>
      <th>Address</th>
      <th>Contact Number</th>
      <th>Clint Name</th>
      <th>Created</th>
      <th>Status</th>
      <th>Action</th>
      <th>View</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of user_data|slice: (page-1) * pageSize : page * pageSize  index as i">
      <td scope="row">{{ i + 1 }}</td>
      <td>{{user.name}}</td>
      <td>{{user.address}}</td>
      <td>{{user.contact_number}}</td>
      <td>{{user.client_name}}</td>
      <td>{{user.created}}</td>
      <td *ngIf="user.status=='Active'">
        <div>
          <p class="p txt-primary">{{user.status}}</p>
        </div>
      </td>
      <td *ngIf="user.status=='Inactive'">
        <div>
          <p class=" txt-danger">{{user.status}}</p>
        </div>
      </td>
      <td> <button ngbTooltip="edit " class="btn btn-success btn-xs" type="button" (click)="onEdit(user)"
          placement="top">edit
        </button> &nbsp;
        <button [disabled]="user.status=='Inactive'" ngbTooltip="delete " class="btn btn-danger btn-xs" type="button"
          (click)="onDelete(user)" placement="top">delete
        </button>
      </td>

      <td>
        <button ngbTooltip="view " class="btn btn-secondary btn-xs" type="button" (click)="onView(user)"
          placement="top">View
        </button>&nbsp;
      </td>
    </tr>
  </tbody>
</table>

<div class="d-flex justify-content-between p-2">
  <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
    (pageChange)="refreshCountries()">
  </ngb-pagination>

  <select class="form-select" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="refreshCountries()">
    <option [ngValue]="2">2 items per page</option>
    <option [ngValue]="3">3 items per page</option>
    <option [ngValue]="6">6 items per page</option>
  </select>
</div>
